import {useEffect, useMemo, useState} from "react";
import {useForm, Controller} from "react-hook-form";
import {yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
	GroupRadioField,
	TextAreaField
} from "~/components/Forms";
import {
	Button,
	Loading,
	StatusLabel
} from "~/components";
import {List, notification} from "antd";
import {apiError, handleRequest} from "../../../../utils";
import {contractApi} from "../../../../api";
import {useUtilities} from "../../../../hooks";

function ContractFormStatus({item, onHandleSubmit})
{
	const {utilities} = useUtilities();

	const [itemsNote, setItemsNote] = useState([])

	const statusOptions = useMemo(() => {
		return [...utilities.status.contractPaper.map((status) => {
			return {
				value: status.key,
				label: <StatusLabel small type={status.badge}>{status.label}</StatusLabel>
			};
		})];
	}, [utilities.status.contractPaper]);

	const initialValues = {
		status: '',
	}

	const validationSchema = Yup.object().shape({
		status: Yup.string().required('Trạng thái thu hồi không được để trống'),
	})

	const { control, handleSubmit, formState: { isSubmitting, errors }, reset } = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	const loadNote = async () => {

		if (!item?.id)
		{
			notification.error({
				message: 'Lỗi',
				description: 'Không có thông tin hợp đồng lấy ghi chú'
			});
			return;
		}

		let [error, response] = await handleRequest(contractApi.note(item.id));

		let message = apiError(`Lấy ghi chú của hợp đồng thất bại`, error, response);

		if (!message) {
			setItemsNote(response.data)
		}
	}

	useEffect(() => {
		if(item?.id) {
			loadNote();
			initialValues.status = item.status.key;
		}
		reset(initialValues);
	}, [item.id, item.status.key]);

	const onSubmit = async (data) => {
		await onHandleSubmit(data, itemsNote, setItemsNote);
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			<p className="heading">Trạng thái</p>
			<Controller control={control} name="status" render={({field}) => (
				<GroupRadioField options={statusOptions} errors={errors} {...field}/>
			)}/>
			<hr />
			{itemsNote && <List
				itemLayout="horizontal"
				dataSource={itemsNote}
				renderItem={(item, index) => (
					<List.Item>
						<List.Item.Meta
							title={item.name}
							description={item.note}
						/>
					</List.Item>
				)}
			/>}
			<hr />
			<Controller control={control} name="note" render={({ field }) => (
				<TextAreaField placeholder="Ghi chú"  errors={errors} {...field} />
			)}/>
			<div className="form-group d-flex justify-content-end modal-bottom">
				<Button primary type="submit">Cập nhật</Button>
			</div>
		</form>
	)
}

export default ContractFormStatus;